'use strict';

export default function routes($stateProvider) 
{
	'ngInject';

	//console.log("Importing main:routes");

	$stateProvider.state('home', {
		url: '/',
		template: '<main></main>'
	});
}



// WEBPACK FOOTER //
// ./client/app/frontend/home/home.routes.js